import { useState } from 'react';

export function Testimonials() {
  const testimonials = [
    {
      text: "Lotus Maternal changed my entire birth experience. Queen Brie was there for me every step of the way, providing emotional support and advocating for my needs. I felt empowered and heard throughout my pregnancy and delivery. I couldn't have done it without her!",
      name: 'Jasmine Williams',
      role: 'First-time Mother',
      image: 'https://public.readdy.ai/ai/img_res/edited_96178051a22bd995a21ccf4b11e12507_70b4df54.jpg',
    },
    {
      text: "The support I received from Lotus Maternal was incredible. From prenatal visits to postpartum care, they were always available and provided culturally competent care that made me feel safe and understood. The meal prep and lactation support were lifesavers!",
      name: 'Aisha Thompson',
      role: 'Mother of Two',
      image: 'https://public.readdy.ai/ai/img_res/edited_e120cd7ac8712abd5546a01e84d67b3f_6c25a369.jpg',
    },
    {
      text: "As a first-time mother, I was nervous about navigating the healthcare system during my pregnancy. Lotus Maternal provided the advocacy and support I needed. They helped me create a birth plan and ensured my voice was heard. I'm so grateful for their compassionate care.",
      name: 'Keisha Davis',
      role: 'New Mother',
      image: 'https://public.readdy.ai/ai/img_res/edited_7af849e4162db766a3b1571b4473e865_450fd44f.jpg',
    },
    {
      text: "From my very first consultation, I knew Lotus Maternal was different. They truly understand the unique challenges families face and show up with so much love and knowledge. My birth was beautiful and I felt completely supported the whole time.",
      name: 'Monique Harris',
      role: 'Mother & Advocate',
      image: 'https://public.readdy.ai/ai/img_res/edited_ae23c977ca8c4742057cf02b318146dd_9af92e9d.jpg',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const prevTestimonial = () => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="min-h-screen flex flex-col">
      {/* Top image banner */}
      <div className="relative h-72 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/686dcc53346829afb7716ae25cc1fcfe.jpg"
          alt="Community of Black mothers"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-white"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-5 py-2 mb-4">
            <i className="ri-star-fill text-yellow-300 text-sm"></i>
            <span className="text-white text-sm font-body font-semibold tracking-wide">Client Stories</span>
          </div>
          <h2 className="font-display text-5xl lg:text-6xl font-bold text-white text-center drop-shadow-lg">
            What Families Say
          </h2>
        </div>
      </div>

      {/* Testimonials grid */}
      <div className="flex-1 bg-white py-16 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Rating bar */}
          <div className="flex items-center justify-center gap-4 mb-14">
            <div className="flex gap-1">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            <span className="font-display text-3xl font-bold text-neutral-charcoal">4.9</span>
            <span className="font-body text-sm text-neutral-gray">/ 5.0 — Trusted by 100+ families</span>
          </div>

          {/* Featured testimonial */}
          <div className="bg-gradient-to-br from-amber-50 to-green-50 rounded-3xl p-10 lg:p-14 mb-10 border border-amber-100">
            <i className="ri-double-quotes-l text-6xl text-amber-600 opacity-40 block mb-6"></i>
            <p className="font-body text-xl text-neutral-charcoal leading-relaxed mb-10 max-w-4xl">
              {testimonials[currentIndex].text}
            </p>
            <div className="flex items-center justify-between flex-wrap gap-6">
              <div className="flex items-center gap-5">
                <div className="w-16 h-16 rounded-full overflow-hidden border-4 border-amber-600 shadow-lg">
                  <img
                    src={testimonials[currentIndex].image}
                    alt={testimonials[currentIndex].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-display text-lg font-bold text-neutral-charcoal">
                    {testimonials[currentIndex].name}
                  </div>
                  <div className="font-body text-sm text-green-700">{testimonials[currentIndex].role}</div>
                  <div className="flex gap-0.5 mt-1">
                    {[1,2,3,4,5].map((s) => (
                      <i key={s} className="ri-star-fill text-yellow-400 text-xs"></i>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex gap-3">
                <button
                  onClick={prevTestimonial}
                  className="w-12 h-12 flex items-center justify-center bg-white border-2 border-amber-600 rounded-full hover:bg-amber-600 hover:text-white transition-all cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-xl"></i>
                </button>
                <button
                  onClick={nextTestimonial}
                  className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-full text-white hover:bg-amber-700 transition-all cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Dot indicators */}
          <div className="flex justify-center gap-2 mb-14">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`rounded-full transition-all cursor-pointer ${i === currentIndex ? 'w-8 h-3 bg-amber-600' : 'w-3 h-3 bg-amber-200'}`}
              />
            ))}
          </div>

          {/* Mini cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {testimonials.map((t, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`text-left bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all cursor-pointer border-2 ${i === currentIndex ? 'border-amber-600' : 'border-transparent'}`}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <div className="font-body text-sm font-semibold text-neutral-charcoal">{t.name}</div>
                    <div className="font-body text-xs text-neutral-gray">{t.role}</div>
                  </div>
                </div>
                <p className="font-body text-xs text-neutral-gray leading-relaxed line-clamp-3">{t.text}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
